// extracted by mini-css-extract-plugin
export var colorSquare = "_rr-0";
export var danger = "_rr-5";
export var lightPink = "_rr-8";
export var neutralBlue = "_rr-7";
export var neutralYellow = "_rr-6";
export var normal = "_rr-1";
export var primary = "_rr-2";
export var primaryLight = "_rr-3";
export var solidBlack = "_rr-g";
export var solidGreen = "_rr-b";
export var solidLightBlue = "_rr-d";
export var solidNavy = "_rr-c";
export var solidOrange = "_rr-f";
export var solidPink = "_rr-e";
export var solidRed = "_rr-9";
export var solidYellow = "_rr-a";
export var success = "_rr-4";